module.exports = __webpack_public_path__ + "static/img/logo.e6468b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/logo.png
// module id = /oCe
// module chunks = 44